import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import ClampUnitCanvas from './CanvasComponents/ClampUnitCanvas';
import HyCAPCanvas from './CanvasComponents/HyCAPCanvas';
import InjectionUnitCanvas from './CanvasComponents/InjectionUnitCanvas';

const MachineCanvas = ({
  hoveredPart,
  setHoveredPart,
  selectedAsset,
  machineName,
  navigationState,
}: any) => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Extract second-to-last segment from URL
  const segment =
    pathSegments.length >= 2
      ? decodeURIComponent(pathSegments[pathSegments.length - 2]).toLowerCase()
      : '';

  // Map for existing asset cases
  const partMap: Record<string, React.FC<any>> = {
    'feed throat': InjectionUnitCanvas,
    'injection cylinder': InjectionUnitCanvas,
    'injection piston': InjectionUnitCanvas,
    'stationary platen': ClampUnitCanvas,
    'extruder barrel heats': InjectionUnitCanvas,
    'extruder barrel': InjectionUnitCanvas,
    mold: ClampUnitCanvas,
  };

  // Map for parent cases
  const machineMap: Record<string, React.FC<any>> = {
    hycap: HyCAPCanvas,
    'clamp unit': ClampUnitCanvas,
    'injection unit': InjectionUnitCanvas,
  };

  const renderCanvas = () => {
    // Check asset-level first
    const partKey = selectedAsset?.toLowerCase();
    if (partKey && partMap[partKey]) {
      const Component = partMap[partKey];
      return (
        <Component
          hoveredPart={hoveredPart}
          setHoveredPart={setHoveredPart}
          machineName={machineName}
          navigationState={navigationState}
        />
      );
    }

    // Otherwise, check parent
    const machineKey = Object.keys(machineMap).find((key) =>
      segment.includes(key)
    );

    if(machineKey && machineMap[machineKey]){
      const Component = machineMap[machineKey];
      return (
        <Component
          hoveredPart={hoveredPart}
          setHoveredPart={setHoveredPart}
          machineName={machineName}
          navigationState={navigationState}
        />
      );
    }
    return null;
  };

  return <Grid container>{renderCanvas()}</Grid>;
};

export default MachineCanvas;
